var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWelloPoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE560",
  d: "M12 22.801c5.964 0 10.8-4.835 10.8-10.8 0-5.964-4.836-10.8-10.8-10.8S1.2 6.037 1.2 12.001s4.835 10.8 10.8 10.8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D6B100",
  d: "m15.261 7.555-1.876 8.538h-2.648l-.628-3.674-.805 3.674H6.812l-1.567-6.072 2.576-.634.505 3.636.719-3.937 2.104-.518.773 4.513.488-4.823 2.85-.701zm3.246 1.485-1.254 4.938h-1.997l.76-6.287zm-1.418 6.679c0 .66-.509 1.194-1.134 1.194-.626 0-1.135-.535-1.135-1.194s.509-1.195 1.134-1.195c.626 0 1.135.536 1.135 1.195"
})));
export default SvgWelloPoint;